/* eslint-disable @typescript-eslint/no-explicit-any */

import { CodatAuthContextType } from "@codat/client-cookie-manager";
import axios, {
  AxiosError,
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
} from "axios";

import { ApiError } from "./shared";

export type InstanceWithTypedRoutes<U extends string> = Omit<
  AxiosInstance,
  "get"
> & {
  get<T, R = AxiosResponse<T>, D = any>(
    url: U,
    config?: AxiosRequestConfig<D>
  ): Promise<R>;
};

const makeApi = (
  auth: CodatAuthContextType,
  baseURL?: string
): AxiosInstance => {
  const token = auth.userData?.access_token;

  const instance = axios.create({
    withCredentials: true,
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      authorization: token ? `Bearer ${token}` : "",
    },

    baseURL: baseURL,
  });

  instance.interceptors.response.use(
    (res) => res,
    (err: AxiosError<ApiError>) => {
      const statusCode = err.response?.status;

      if (statusCode === 401) {
        auth.signIn();
      }

      if (statusCode === 402) {
        auth.selectClient();
      }

      if (statusCode === 403) {
        auth.selectClient();
      }

      throw err;
    }
  );

  return instance;
};

export default makeApi;
